export default __webpack_public_path__ + "static/media/premiumdentures1.32927e47.png";